<div class="header-logo">
  <img class="logo logo--interreg" src="img/AsseV_GovernaTI-VA.png" alt="Logo Interreg" />
  <div class="other-logos">
    <div style="width: 0px;" />
    <img class="logo" style="height: 50px;" src="img/varese_logo.png" alt="Logo Varese" />
    <img class="logo" style="height: 30px;" src="img/svizzera_logo.png" alt="Logo Svizzera" />
    <div style="width: 0px;" />
    <img class="logo" style="height: 50px;" src="img/ticino_logo.png" alt="Logo Ticino" />
    <img class="logo" style="height: 25px;" src="img/anci_logo.png" alt="Logo Anci" />
    <img class="logo" style="height: 25px;" src="img/ppp_logo.png" alt="Logo Ppp" />
  </div>
</div>

<style>
  .header-logo {
    display: flex;
    width: 100%;
    background-color: #fff;
    gap: 0.5rem;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 10px;
    padding-bottom: 25px;
  }

  .logo--interreg {
    height: 40px;
    padding-left: 10px;
  }

  .other-logos {
    display: flex;
    flex: 1;
    justify-content: space-around;
    align-items: center;
    gap: 0.5rem;
    padding-right: 10px;
  }
</style>
